export function htmlCampaignAcquisition() {
  return (
    <>
      <hr />

      <h5>Aquisição de Campanha</h5>

      <p>
        A Aquisição de Campanha corresponde à taxa necessária para criação,
        disponibilização e utilização de uma nova Campanha dentro da Plataforma.
      </p>

      <p>
        Este valor contribui para as custas de funcionamento da Plataforma,
        incluindo infraestrutura, processamento, manutenção, suporte,
        desenvolvimento contínuo, segurança e demais serviços necessários para
        manter a Campanha disponível e operacional.
      </p>

      <p>
        O valor da Aquisição de Campanha pode variar conforme o tipo, modelo ou
        condições escolhidas no momento da criação.
      </p>
    </>
  );
}
